import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default function (element, data) {
    const swiperContainer = element.querySelector('.resources-swiper');
    const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    const nextBtn = element.querySelector(".swiper-button-next");
    const prevBtn = element.querySelector(".swiper-button-prev");

    const swiperOptions = {
        modules: [Navigation],
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 10,
        centeredSlides: true,
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        breakpoints: {
            1240: {
                slidesOffsetAfter: 125,
            },
            768: {
                slidesOffsetAfter: 60,
            }
        }
    };

    if (slides.length > 1 && slides.length < 12) {
        while (swiperWrapper.children.length < 12) {      
            const currentSlides = Array.from(swiperWrapper.children);

            currentSlides.forEach(slide => {
                if (swiperWrapper.children.length < 12) {
                    const cloneSlide = slide.cloneNode(true);
                    swiperWrapper.appendChild(cloneSlide);
                }
            });
        }
    }

    Fancybox.bind(`[data-fancybox]`, {
        // groupAll: true,
    });

    element.swiper = new Swiper(swiperContainer, swiperOptions);
};